import { Animated } from 'react-native';
import { createMotionComponent } from './createMotionComponent';
import { MotionPressable } from './MotionPressable';
export let Motion;
(function (_Motion) {
  const View = _Motion.View = createMotionComponent(Animated.View);
  const Text = _Motion.Text = createMotionComponent(Animated.Text);
  const FlatList = _Motion.FlatList = createMotionComponent(Animated.FlatList);
  const Image = _Motion.Image = createMotionComponent(Animated.Image);
  const ScrollView = _Motion.ScrollView = createMotionComponent(Animated.ScrollView);
  const SectionList = _Motion.SectionList = createMotionComponent(Animated.SectionList);
  const Pressable = _Motion.Pressable = MotionPressable;
})(Motion || (Motion = {}));
//# sourceMappingURL=AnimatedComponents.js.map